import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const gridAreas = ["a", "b", "c", "d", "e"];

const CategoryGrid = ({ allCategories = [] }) => {
  const navigate = useNavigate();
  const items = allCategories.slice(0, 5).map((item, index) => {
    const image = item?.categoryImages?.[0]?.Image || "/images/placeholder.png";
    const title = item?.categoryLocales?.[0]?.name || "Category";

    return {
      id: item.id,
      slug: item?.slug || "",
      image,
      title,
      count: item?.productCount ?? 0,
      gridArea: gridAreas[index],
      isOverlapping: index === 3,
      isOverLapped: index === 1,
    };
  });

  const handleCategoryClick = (slug, id) => {
    if (slug && id) {
      navigate(`/productlist/${slug}/${id}`);
    }
  };

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        maxWidth: 1200,
        mx: "auto",
        px: 2,
        display: "grid",
        gap: 2,

        gridTemplateAreas: {
          xs: `
            "a b"
            "c d"
            "e e"
          `,
          md: `
            "a b b"
            "c d e"
          `,
        },

        gridTemplateColumns: {
          xs: "1fr 1fr",
          md: "1fr 1fr 1fr",
        },
      }}
    >
      {items.map((item) => (
        <Box
          key={item.id}
          onClick={() => handleCategoryClick(item.slug, item.id)}
          sx={{
            gridArea: item.gridArea,
            position: {
              xs: "relative",
              md: item.isOverlapping ? "absolute" : "relative",
            },

            ...(item.isOverlapping && {
              right: { md: 0 },
              bottom: { md: 0 },
              width: { md: 340 },
              height: { md: 440 },
              
            }),

            height: item.isOverlapping
              ? { xs: 180, md: "auto" }
              : { xs: 180, md: 260 },

            borderRadius: "20px",
            overflow: "hidden",
            cursor: "pointer",
            transition: "all 0.3s ease",

            "&:hover": {
              transform: "scale(1.03)",
              boxShadow: "0 8px 24px rgba(119, 18, 55, 0.15)",
            },

            "&:active": {
              transform: "scale(0.98)",
            },
          }}
        >
          <Box
            component="img"
            src={item.image}
            alt={item.title}
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              ...(item.isOverLapped && {
              clipPath: {
                md: "polygon(100% 0%, 72% 0%, 38% 0%, 0% 0%, 0% 25%, 0% 52%, 0% 69%, 26% 69%, 52% 69%, 52% 100%, 77% 100%, 100% 100%, 100% 51%, 100% 25%)",
              },
            })

            }}
          />
          {item.count > 0 && (
            <Box
              sx={{
                position: "absolute",
                top: 12,
                right: 12,
                backgroundColor: "#fff",
                px: 1.5,
                py: 0.5,
                borderRadius: "999px",
                fontSize: 12,
                fontWeight: 500,
                color: "#771237",
                pointerEvents: "none",
              }}
            >
              {item.count} Cake
            </Box>
          )}
          <Box
            sx={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              p: 2,
              background:
                "linear-gradient(to top, rgba(0,0,0,0.6), transparent)",
              pointerEvents: "none",
            }}
          >
            <Typography
              sx={{
                color: "#fff",
                fontSize: 16,
                fontFamily: "'Unbounded', sans-serif",
                fontWeight: 600,
                textAlign: { xs: "left", md: "center" },
                ...(item.isOverLapped && { textAlign: { md: "right", xs: "center" } }),
              }}
            >
              {item.title}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default CategoryGrid;
